import { TinyColor, readability } from '@ctrl/tinycolor';
import type { BrandingColor } from 'shared/branding';

const surfaces = ['#ffffff', '#fafafa', '#f3f4f6', '#e5e7eb'];

/** Keep tenant hue while making semantic text accessible on helper surfaces. */
export function helperSemanticColors(
  branding?: Pick<BrandingColor, 'primaryColorHex'>,
): Record<string, string> {
  const candidate = new TinyColor(branding?.primaryColorHex ?? '#1976d2');
  let primary = (
    candidate.isValid ? candidate : new TinyColor('#1976d2')
  ).setAlpha(1);
  const container = new TinyColor('#ffffff').mix(primary, 12).toHexString();
  while (
    [...surfaces, container].some(
      (surface) => readability(primary, surface) < 4.5,
    )
  ) {
    primary = primary.darken(1);
  }
  return {
    '--mat-sys-primary': primary.toHexString(),
    '--mat-sys-on-primary': '#ffffff',
    '--mat-sys-primary-container': container,
    '--mat-sys-on-primary-container': primary.toHexString(),
  };
}
